// Mock data for the B.health registration form

export const formConfig = {
  title: "Inscription B.health®",
  description: `Fiche informatique d'inscription validée. Conformément aux dispositions légales en vigueur, cette inscription est définitive et ne peut faire l'objet d'une rétractation sauf prescription légale. Merci de vérifier attentivement vos données. En cas d'incohérence, merci de nous contacter par email ou directement par téléphone. Merci pour votre confiance.`,
  submitButtonText: "Pour accord",
};

// Abonnement options with price and duration (in months)
// Prices from the CRM catalog
export const abonnementOptionsWithDetails = [
  { 
    label: "Annuel", 
    durationMonths: 12, 
    prices: { 
      Simple: 699, 
      Etudiant: 599, 
      Senior: 599, 
      Famille: 560, // par personne, min 2 personnes
      "Wolvendael / Staff Communal / Membre Bsports Tennis": 559 // -20% de 699€
    },
    notes: {
      Famille: "par personne (minimum 2 personnes)",
      "Wolvendael / Staff Communal / Membre Bsports Tennis": "(-20%)"
    }
  },
  { 
    label: "Semestriel", 
    durationMonths: 6, 
    prices: { 
      Simple: 465, 
      Etudiant: 380, 
      Senior: 465, 
      Famille: null, // pas disponible
      "Wolvendael / Staff Communal / Membre Bsports Tennis": null // pas disponible
    } 
  },
  { 
    label: "Domiciliation", 
    durationMonths: 12, 
    prices: { 
      Simple: 69, 
      Etudiant: 59, 
      Senior: 59, 
      Famille: 56, // par personne, min 2 personnes
      "Wolvendael / Staff Communal / Membre Bsports Tennis": 55
    }, 
    perMonth: true,
    notes: {
      Famille: "par personne (minimum 2 personnes)"
    }
  },
  { 
    label: "30 accès (Valable 7 mois)", 
    durationMonths: 7, 
    prices: { 
      Simple: 420, 
      Etudiant: 420, 
      Senior: 420, 
      Famille: 420, 
      "Wolvendael / Staff Communal / Membre Bsports Tennis": 420 
    } 
  },
  { 
    label: "6 mois sur un an", 
    durationMonths: 12, 
    prices: { 
      Simple: 495, 
      Etudiant: 495, 
      Senior: 495, 
      Famille: 495, 
      "Wolvendael / Staff Communal / Membre Bsports Tennis": 495 
    } 
  },
  { 
    label: "20 accès (Valable 4 mois)", 
    durationMonths: 4, 
    prices: { 
      Simple: 320, 
      Etudiant: 320, 
      Senior: 320, 
      Famille: 320, 
      "Wolvendael / Staff Communal / Membre Bsports Tennis": 320 
    } 
  },
];

export const abonnementOptions = abonnementOptionsWithDetails.map(a => a.label);

export const statutMembreOptions = [
  "Simple",
  "Etudiant",
  "Senior",
  "Famille",
  "Wolvendael / Staff Communal / Membre Bsports Tennis",
];

export const cleTCGOptions = ["oui", "non"];

export const dechargeOptions = [
  "J'accepte la décharges de responsabilité pour l'accès au centre sans supervision.",
  "Je désire uniquement m'entrainer pendant les heures de supervision.",
];

export const formulaireAideOptions = [
  "Elysee",
  "Gaëtan",
  "Mathias",
  "Brayane",
  "Rafael",
];

export const paiementOptions = [
  "Bancontact (boitier MyPos)",
  "QR code Bancontact",
  "Facture et virement bancaire endéans 3 jours",
  "Paiement en numéraire",
  "Paiement en 3 fois avec votre partenaire Floapay (dossier à remplir)",
];

export const dechargeText = {
  title: "DÉCHARGE DE RESPONSABILITÉ EN CAS D'UTILISATION DE LA SALLE EN ACCÈS LIBRE SANS SUPERVISION",
  intro: "Entre les soussignés :",
  company: "B.health (HFM SRL)",
  companyAddress: "Siège social : 14, rue de la Basilique, 1082 Berchem-Sainte-Agathe, Belgique",
  companyNumber: "Numéro d'entreprise : 0651.880.679",
  companyRef: 'Ci-après dénommé "le Centre"',
  memberRef: 'La personne souscrivant tout type d\'abonnement au centre Ci-après dénommé "le Membre"',
  objectTitle: "Objet de la décharge :",
  objectText: "Le Membre reconnaît et accepte que l'utilisation des installations du Centre en accès libre, sans la supervision directe d'un coach ou d'un membre du personnel, entraîne des risques inhérents à la pratique d'activités physiques et sportives.",
  declarationIntro: "En acceptant la présente décharge, le Membre déclare :",
  declarations: [
    "Avoir pris connaissance que l'accès libre aux équipements et espaces du Centre s'effectue à ses propres risques et périls.",
    "Être apte physiquement à pratiquer une activité physique.",
    "Utiliser les équipements de manière appropriée et conforme aux consignes de sécurité affichées et communiquées.",
    "Dégager expressément B.health (HFM SRL), ses dirigeants, salariés et partenaires de toute responsabilité en cas d'accident, blessure ou dommage survenu lors de l'utilisation des installations sans encadrement direct.",
    "Reconnaître que cette décharge couvre toute blessure, qu'elle soit légère, grave ou ayant des conséquences permanentes.",
  ],
  assuranceTitle: "Assurance personnelle :",
  assuranceText: "Le Membre reconnaît avoir été informé de l'importance de souscrire à une assurance personnelle couvrant les risques liés à la pratique sportive.",
  nonAcceptText: "En cas de non acceptation de cette décharge, le membre est expréssement invité à ne venir s'entrainer que pendant les horaire de supervision. Horaire à disposition du membre via l'application mobile du centre.",
  dureeTitle: "Durée :",
  dureeText: "Cette décharge est valable pour toute la durée de l'abonnement du Membre au Centre B.health.",
  diversTitle: "Divers :",
  diversText: "En cas de litige relatif à l'interprétation ou à l'exécution de la présente décharge, seuls les tribunaux de l'arrondissement judiciaire de Bruxelles seront compétents.",
};

// Helper function to calculate end date based on subscription
export const calculateEndDate = (startDate, subscriptionLabel) => {
  if (!startDate || !subscriptionLabel) return null;
  
  const subscription = abonnementOptionsWithDetails.find(a => a.label === subscriptionLabel);
  if (!subscription) return null;
  
  const endDate = new Date(startDate);
  endDate.setMonth(endDate.getMonth() + subscription.durationMonths);
  return endDate;
};

// Helper function to get price based on subscription and member status
export const getPrice = (subscriptionLabel, memberStatus) => {
  if (!subscriptionLabel || !memberStatus) return "";
  
  const subscription = abonnementOptionsWithDetails.find(a => a.label === subscriptionLabel);
  if (!subscription) return "";
  
  const price = subscription.prices[memberStatus];
  
  // Check if this combination is not available
  if (price === null || price === undefined) {
    return "Non disponible";
  }
  
  // Get note if exists
  const note = subscription.notes?.[memberStatus] || "";
  
  if (subscription.perMonth) {
    return `${price}€/mois${note ? ' ' + note : ''}`;
  }
  // Always include € symbol for non-monthly subscriptions
  return `${price}€${note ? ' ' + note : ''}`;
};
